<section class="perfil-form">
  <article class="acordeon" [class.abierto]="estaAbierto('identidad')">
    <button type="button" class="acordeon-cabecera" (click)="alternar('identidad')" [attr.aria-expanded]="estaAbierto('identidad')">
      <span>Identidad y Nacionalidad</span>
      <span class="acordeon-icono" aria-hidden="true"></span>
    </button>
    <div class="acordeon-cuerpo" *ngIf="estaAbierto('identidad')">
      <div class="perfil-grid">
        <label>
          Primer nombre <span class="required-mark">*</span>
          <input type="text" [(ngModel)]="datosPersonales.primerNombre" placeholder="Texto de ejemplo" />
        </label>
        <label>
          Segundo nombre <span class="required-mark">*</span>
          <input type="text" [(ngModel)]="datosPersonales.segundoNombre" placeholder="Texto de ejemplo" />
        </label>
        <label>
          Primer apellido <span class="required-mark">*</span>
          <input type="text" [(ngModel)]="datosPersonales.primerApellido" placeholder="Texto de ejemplo" />
        </label>
        <label>
          Segundo apellido <span class="required-mark">*</span>
          <input type="text" [(ngModel)]="datosPersonales.segundoApellido" placeholder="Texto de ejemplo" />
        </label>
        <label>
          Rut <span class="required-mark">*</span>
          <input type="text" [(ngModel)]="datosPersonales.runPasaporte" [readonly]="datosPersonales.runBloqueado" placeholder="00 000 000-0" />
          <small class="field-help" *ngIf="datosPersonales.runBloqueado">Dato bloqueado tras su primer guardado.</small>
          <small class="field-error" *ngIf="errores['runPasaporte']">{{ errores['runPasaporte'] }}</small>
        </label>
        <label>
          Fecha de nacimiento <span class="required-mark">*</span>
          <input type="date" [(ngModel)]="datosPersonales.fechaNacimiento" />
        </label>
        <label>
          Nacionalidad <span class="required-mark">*</span>
          <select [(ngModel)]="datosPersonales.nacionalidad">
            <option value="">Seleccionar</option>
            <option *ngFor="let item of nacionalidades" [value]="item">{{ item }}</option>
          </select>
        </label>
        <label>
          Nombre social completo
          <input type="text" [(ngModel)]="datosPersonales.nombreSocialCompleto" placeholder="Texto de ejemplo" />
          <small class="field-help">Opcional</small>
        </label>
      </div>
      <div class="acordeon-acciones">
        <button type="button" class="btn-continuar" (click)="guardarYContinuar('identidad')">Guardar y continuar <span class="btn-plus" aria-hidden="true">+</span></button>
      </div>
    </div>
  </article>

  <article class="acordeon" [class.abierto]="estaAbierto('contacto')">
    <button type="button" class="acordeon-cabecera" (click)="alternar('contacto')" [attr.aria-expanded]="estaAbierto('contacto')">
      <span>Información de Contacto</span>
      <span class="acordeon-icono" aria-hidden="true"></span>
    </button>
    <div class="acordeon-cuerpo" *ngIf="estaAbierto('contacto')">
      <div class="perfil-grid">
        <label>
          Correo principal <span class="required-mark">*</span>
          <input type="email" [(ngModel)]="datosPersonales.correoPrincipal" placeholder="textodeejemplo@gmail.com" />
          <small class="field-error" *ngIf="errores['correoPrincipal']">{{ errores['correoPrincipal'] }}</small>
        </label>
        <label>
          Correo alternativo <span class="required-mark">*</span>
          <input type="email" [(ngModel)]="datosPersonales.correoAlternativo" placeholder="Texto de ejemplo" />
          <small class="field-help">En caso de pérdida de acceso.</small>
          <small class="field-error" *ngIf="errores['correoAlternativo']">{{ errores['correoAlternativo'] }}</small>
        </label>
        <label>
          Teléfono <span class="required-mark">*</span>
          <input type="text" [(ngModel)]="datosPersonales.telefono" placeholder="+00 0 0000 0000" />
          <small class="field-error" *ngIf="errores['telefono']">{{ errores['telefono'] }}</small>
        </label>
      </div>

      <div class="direccion-bloque" *ngFor="let direccion of datosPersonales.direcciones; let i = index">
        <div class="perfil-grid">
          <label>
            Dirección <span class="required-mark">*</span>
            <select [(ngModel)]="direccion.tipo">
              <option value="">Seleccionar</option>
              <option *ngFor="let item of tiposDireccion" [value]="item">{{ item }}</option>
            </select>
          </label>
          <label>
            País de residencia <span class="required-mark">*</span>
            <select [(ngModel)]="direccion.paisResidencia">
              <option value="">Seleccionar</option>
              <option *ngFor="let item of paises" [value]="item">{{ item }}</option>
            </select>
          </label>
          <label>
            Región <span class="required-mark">*</span>
            <select [(ngModel)]="direccion.region">
              <option value="">Seleccionar</option>
              <option *ngFor="let item of regiones" [value]="item">{{ item }}</option>
            </select>
          </label>
          <label>
            Comuna <span class="required-mark">*</span>
            <select [(ngModel)]="direccion.comuna">
              <option value="">Seleccionar</option>
              <option *ngFor="let item of comunas(direccion.region)" [value]="item">{{ item }}</option>
            </select>
          </label>
          <label class="full-row">
            Calle / Número / Departamento
            <input type="text" [(ngModel)]="direccion.calleNumeroDepto" placeholder="Ingresar detalle" />
          </label>
          <label class="full-row">
            Referencia adicional
            <input type="text" [(ngModel)]="direccion.referenciaAdicional" placeholder="Ingresar detalle" />
            <small class="field-help">Opcional. Ingrese detalles que ayuden a ubicar su dirección, si es necesario</small>
          </label>
        </div>
      </div>

      <div class="acordeon-acciones split">
        <button type="button" class="btn-continuar" (click)="agregarDireccion()">Agregar otra dirección <span class="btn-plus" aria-hidden="true">+</span></button>
        <button type="button" class="btn-continuar" (click)="guardarYContinuar('contacto')">Guardar y continuar <span class="btn-plus" aria-hidden="true">+</span></button>
      </div>
    </div>
  </article>

  <article class="acordeon" [class.abierto]="estaAbierto('diversidad')">
    <button type="button" class="acordeon-cabecera" (click)="alternar('diversidad')" [attr.aria-expanded]="estaAbierto('diversidad')">
      <span>Identidad y Diversidad</span>
      <span class="acordeon-icono" aria-hidden="true"></span>
    </button>
    <div class="acordeon-cuerpo" *ngIf="estaAbierto('diversidad')">
      <div class="perfil-grid">
        <label>
          Género registral <span class="required-mark">*</span>
          <select [(ngModel)]="datosPersonales.generoRegistral">
            <option value="">Seleccionar</option>
            <option *ngFor="let item of generosRegistrales" [value]="item">{{ item }}</option>
          </select>
        </label>
        <label>
          Género declarativo
          <select [(ngModel)]="datosPersonales.generoDeclarativo">
            <option value="">Seleccionar</option>
            <option *ngFor="let item of generosDeclarativos" [value]="item">{{ item }}</option>
          </select>
          <small class="field-help">Opcional</small>
        </label>
        <fieldset class="radio-group">
          <legend>Pueblo originario <span class="required-mark">*</span></legend>
          <p class="field-help">Seleccione si pertenece a un pueblo originario o indígena reconocido.</p>
          <div class="radio-row">
            <label class="radio">
              <input type="radio" name="pueblo" value="si" [(ngModel)]="datosPersonales.puebloOriginario" (ngModelChange)="onPuebloOriginarioChange($event)" />
              Sí
            </label>
            <label class="radio">
              <input type="radio" name="pueblo" value="no" [(ngModel)]="datosPersonales.puebloOriginario" (ngModelChange)="onPuebloOriginarioChange($event)" />
              No
            </label>
          </div>
          <label class="condicional" *ngIf="muestraPuebloPertenencia">
            Pueblo originario al que pertenece <span class="required-mark">*</span>
            <select [(ngModel)]="datosPersonales.puebloAlQuePertenece">
              <option value="">Seleccionar</option>
              <option *ngFor="let item of pueblosOriginarios" [value]="item">{{ item }}</option>
            </select>
          </label>
        </fieldset>
        <fieldset class="radio-group">
          <legend>Discapacidad <span class="required-mark">*</span></legend>
          <p class="field-help">La documentación de respaldo (certificados) se pedirá en la sección correspondiente de anexos de su postulación, no es necesario subirla aquí.</p>
          <div class="radio-row">
            <label class="radio"><input type="radio" name="discapacidad" value="si" [(ngModel)]="datosPersonales.discapacidadSiNo" /> Sí</label>
            <label class="radio"><input type="radio" name="discapacidad" value="no" [(ngModel)]="datosPersonales.discapacidadSiNo" /> No</label>
          </div>
        </fieldset>
      </div>
      <div class="acordeon-acciones">
        <button type="button" class="btn-continuar" (click)="guardarYContinuar('diversidad')">Guardar y continuar <span class="btn-plus" aria-hidden="true">+</span></button>
      </div>
    </div>
  </article>

  <article class="acordeon" [class.abierto]="estaAbierto('familia')">
    <button type="button" class="acordeon-cabecera" (click)="alternar('familia')" [attr.aria-expanded]="estaAbierto('familia')">
      <span>Mi familia</span>
      <span class="acordeon-icono" aria-hidden="true"></span>
    </button>
    <div class="acordeon-cuerpo" *ngIf="estaAbierto('familia')">
      <div class="perfil-grid">
        <fieldset class="radio-group">
          <legend>¿Tiene hijos, hijas o tuición legal de menores de edad? <span class="required-mark">*</span></legend>
          <p class="field-help">La documentación de respaldo se solicitará en la sección de anexos al postular, no en este perfil.</p>
          <div class="radio-row">
            <label class="radio">
              <input type="radio" name="hijos" value="si" [(ngModel)]="datosPersonales.tieneHijos" (ngModelChange)="onTieneHijosChange($event)" />
              Sí
            </label>
            <label class="radio">
              <input type="radio" name="hijos" value="no" [(ngModel)]="datosPersonales.tieneHijos" (ngModelChange)="onTieneHijosChange($event)" />
              No
            </label>
          </div>
          <label class="condicional" *ngIf="muestraCantidadHijos">
            Cantidad de hijos, hijas o tuición legal
            <input type="number" min="1" max="10" step="1" [(ngModel)]="datosPersonales.cantidadHijos" (ngModelChange)="onCantidadHijosChange($event)" />
          </label>
        </fieldset>
        <label>
          ¿Declara cónyuge y/o conviviente civil <span class="required-mark">*</span>
          <select [(ngModel)]="datosPersonales.conyugeConviviente">
            <option value="">Seleccionar</option>
            <option *ngFor="let item of opcionesConyuge" [value]="item">{{ item }}</option>
          </select>
        </label>
      </div>
      <div class="acordeon-acciones">
        <button type="button" class="btn-finalizar" (click)="guardarYFinalizar()">Guardar y finalizar <span class="btn-plus" aria-hidden="true">+</span></button>
      </div>
    </div>
  </article>

  <p class="save-message" *ngIf="mensajeGuardado">{{ mensajeGuardado }}</p>
</section>
